var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-logout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b-logout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2.832V5.07a8 8 0 1 0 8.001 0V2.833A10.003 10.003 0 0 1 20 12c0 5.523-4.477 10-10 10S0 17.523 0 12c0-4.1 2.468-7.625 6-9.168ZM10 0a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a-logout)",
    transform: "translate(-50 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b-logout)",
    transform: "translate(50 765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h20v22H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/iconLogout.b151e60e30ffc86186d6cd382cd91f5b.svg";
export { ForwardRef as ReactComponent };